export const COMMERCIAL_HUB_FAQS = [
 {
 question: "Are you framework-ready for council and housing-association procurement?",
 answer:
 "Yes. We work with councils, housing associations, facilities managers, landlords and main contractors under framework agreements, with RAMS, insurances, PAS 2035 coordination where applicable, TrustMark lodgement and reporting expected at that level. A current capability statement is available on request.",
 },
 {
 question: "Do you handle portfolio rollouts across multiple properties or sites?",
 answer:
 "Yes. We mobilise whole-stock surveys, sequence coordinated design and install programmes across properties or sites, rather than isolated one-off measures. Programme adherence, H&S and snagging are reported back to the buyer.",
 },
 {
 question: "How do PAS 2035, PAS 2030 and TrustMark lodgement work on your programmes?",
 answer:
 "PAS 2035 governs the coordinated retrofit process, assessment, design and measure sequencing. PAS 2030 applies to the installation standards for insulation and ventilation works. TrustMark lodgement is completed on completion so the works are registered and evidenced. We document each stage for your diligence pack.",
 },
 {
 question: "Can you report carbon and social-value outcomes in our format?",
 answer:
 "Yes. Carbon, decarbonisation and social-value outcomes are reported per project or per portfolio in the buyer's preferred format. Claims are evidenced against the agreed reporting framework, not quoted generically.",
 },
 {
 question: "Do you provide social-value reporting?",
 answer:
 "Yes. We report on local jobs, apprenticeships, local supply chain and community benefit on a per-project or per-portfolio basis. Specifics are agreed up front to match the buyer's social-value framework.",
 },
 {
 question: "Is a capability statement available?",
 answer:
 "Yes. We provide a current capability statement and accreditation pack on request, with renewal dates for each accreditation and insurance to reduce diligence friction.",
 },
];
